import { createActions } from 'redux-actions';

import types from 'state/app/actionTypes';

const { app } = createActions({
  [types.initApp$]: () => ({}),
  [types.resetApp$]: () => ({}),
  [types.updateUser$]: () => ({}),
  [types.INIT_APP_FINISHED]: () => ({}),
});

export default app;
